import React from 'react'
import Main from './Main'
import ServiceBtn from "./Services/ServiceBtn"
import fakerImage from './assets/img/undraw_Browsing_online_re_umsa.png'
import githubImage from './assets/img/undraw_Profile_re_4a55.png'
import colorPicker from './assets/img/undraw_color_palette_yamk.png'
import movie from './assets/img/undraw_online_video_ivvq.png'
import password from './assets/img/undraw_authentication_fsn5.png'
import colorConversion from './assets/img/undraw_color__schemes_wv48.png'
import demo from './assets/img/demo.png'

function Service() {
    return (
        <>
            <Main active="service">
                <div className="main">
                    <section>
                        <div className="container section-title">
                            <h2>Services</h2>
                            <div className="row" style={{ "marginTop": "30px" }}>
                                <div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={fakerImage} alt="" className="rounded mx-auto d-block" />
                                        <h5>Faker Details Generator</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="service/faker" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={githubImage} alt="" style={{ "height": "145px" }} className="rounded mx-auto d-block" />
                                        <h5>Github User</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="service/github-user" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={colorPicker} alt="" style={{ "height": "145px" }} className="rounded mx-auto d-block" />
                                        <h5>Color Picker</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="service/color-picker" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={colorConversion} alt="" style={{ "height": "145px" }} className="rounded mx-auto d-block" />
                                        <h5>Color Convertor</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="/service/color-conversion" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={movie} alt="" style={{ "height": "145px" }} className="rounded mx-auto d-block" />
                                        <h5>Movie Details</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="service/movies" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={password} alt="" style={{ "height": "145px" }} className="rounded mx-auto d-block" />
                                        <h5>Password Generator</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="/service/password-generator" />
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={demo} alt="" style={{ "height": "145px" }} className="rounded mx-auto d-block" />
                                        <h5>Other Project's Demo</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="/service/demo" />
                                        </div>
                                    </div>
                                </div>*/}
                            </div>
                        </div>
                    </section>
                </div>
            </Main>
        </>
    )
}

export default Service
